module.exports = __webpack_public_path__ + "static/img/title.eca127d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/title.png
// module id = pgmO
// module chunks = 37